//This is hte main chart theme for dashboard. Bar has been configured but otehrs will need tweaking as we make charts in them


// Colors
const colors = [
  "#FFFFFF",
  "#FFFFFF"
];

// Typography
const sansSerif = "'Roboto', 'Helvetica Neue', Helvetica, sans-serif";
const letterSpacing = "normal";
const fontSize = 4;

// Layout
const padding = 2;

const baseProps = {
  width: 100,
  height: 82,
  padding: {top: 2, bottom: 13, left: 15, right: 15}
};

// * Labels
const baseLabelStyles = {
  fontFamily: sansSerif,
  fontSize,
  letterSpacing,
  padding,
  fill: "#56565a",
  stroke: "#000000",
  strokeWidth: 0
};

function PieTheme() {
  return {
    legend: {
      colorScale: colors,
      gutter: 10,
      orientation: "vertical",
      titleOrientation: "top",
      style: {
        data: {
          type: "square"
        },
        labels: baseLabelStyles,
        title: Object.assign({}, baseLabelStyles, { padding: 5 })
      }
    },
    pie: Object.assign(
      {
        style: {
          data: {
            padding,
            stroke: "transparent",
            strokeWidth: 0
          },
          labels: Object.assign({}, baseLabelStyles, { padding: 2 })
        }
      },
      baseProps
    )
  };
};

export default PieTheme;